export default __webpack_public_path__ + "static/media/lethargy2.59d97f25.png";